import ModalBase from '../base/modalBase';
import eModalType from './eModalType';
import eSymbolType from '../symbol/eSymbolType';
import selectors from '../../redux/game/selectors';
import { store } from '../../index';

export default class ModalPaytable extends ModalBase {

  constructor(data, displayData) {
    super(data, displayData);

    this.type = eModalType.EMT_PAYTABLE;
    this.initListener();
    this.initBlocker();

    this.slides = [];
    this.currentSlide = 0;
    for (let i = 0; i < 4; i++) {
      const slide = this.getChildByName(`slide_${i}`);
      slide.visible = i === this.currentSlide;
      this.slides.push(slide);
    }

    this.paytable = selectors.getPaytable(store.getState());
    this.initSlide2();
    this.initSlide3();

    const buttons = this.getChildByName('buttons');
    buttons.getChildByName('buttonClose').addListener('pointertap', this.onCloseClicked);
    buttons.getChildByName('buttonPrev').addListener('pointertap', this.onPrevClicked);
    buttons.getChildByName('buttonNext').addListener('pointertap', this.onNextClicked);
  }

  initSlide2() {
    const symbols = [eSymbolType.EST_FROG, eSymbolType.EST_MONKEY, eSymbolType.EST_TOUCAN];
    this.initCoefsLabels(this.slides[2], symbols);
  }

  initSlide3() {
    const symbols = [
      eSymbolType.EST_LOW_PURPLE,
      eSymbolType.EST_LOW_GREEN,
      eSymbolType.EST_LOW_BLUE,
      eSymbolType.EST_LOW_ORANGE,
    ];

    this.initCoefsLabels(this.slides[3], symbols);
  }

  initCoefsLabels(slide, symbols) {
    for (let type of symbols) {
      const item = slide.getChildByName(`coefs_view_${type}`);
      for (let i = 2; i < 7; i++) {
        let textPair = item.getChildByName(`coef_view_${i - 2}`);
        textPair.getChildByName('viewCount').text = i + 1;
        textPair.getChildByName('viewCoef').text = `×${this.paytable[type][i]}`;
      }
    }
  }

  onPrevClicked = () => {
    this.slides[this.currentSlide].visible = false;
    this.currentSlide = (4 + this.currentSlide - 1) % 4;
    this.slides[this.currentSlide].visible = true;
  };

  onNextClicked = () => {
    this.slides[this.currentSlide].visible = false;
    this.currentSlide = (this.currentSlide + 1) % 4;
    this.slides[this.currentSlide].visible = true;
  };
}
